import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="page-full">
      <div className="header">
        <button className="icon-btn" data-testid="back-btn" onClick={() => navigate(-1)}>←</button>
        <h1 className="header-title">Política de Privacidad</h1>
      </div>
      <div className="content-scroll">
        <div className="info-card">
          <h2 style={{ marginBottom: '16px', fontSize: '20px' }}>Política de Privacidad de TUKI Business</h2>
          
          <p style={{ color: 'var(--text2)', lineHeight: '24px', marginBottom: '16px' }}>
            <strong>Última actualización:</strong> Enero 2026
          </p>

          <h3 style={{ marginTop: '20px', marginBottom: '12px', fontSize: '16px' }}>1. Información que Recopilamos</h3>
          <p style={{ color: 'var(--text2)', lineHeight: '24px', marginBottom: '16px' }}>
            Recopilamos información que nos proporcionas directamente, incluyendo nombre del negocio, 
            datos de contacto, información de clientes y transacciones comerciales.
          </p>

          <h3 style={{ marginTop: '20px', marginBottom: '12px', fontSize: '16px' }}>2. Uso de la Información</h3>
          <p style={{ color: 'var(--text2)', lineHeight: '24px', marginBottom: '16px' }}>
            Utilizamos la información recopilada para:
          </p>
          <ul style={{ color: 'var(--text2)', lineHeight: '24px', marginBottom: '16px', paddingLeft: '20px' }}>
            <li>Proveer y mejorar nuestros servicios</li>
            <li>Gestionar tu cuenta y preferencias</li>
            <li>Procesar transacciones</li>
            <li>Enviar comunicaciones relacionadas con el servicio</li>
          </ul>

          <h3 style={{ marginTop: '20px', marginBottom: '12px', fontSize: '16px' }}>3. Protección de Datos</h3>
          <p style={{ color: 'var(--text2)', lineHeight: '24px', marginBottom: '16px' }}>
            Implementamos medidas de seguridad técnicas y organizativas para proteger tu información 
            contra accesos no autorizados, alteración o destrucción.
          </p>

          <h3 style={{ marginTop: '20px', marginBottom: '12px', fontSize: '16px' }}>4. Compartir Información</h3>
          <p style={{ color: 'var(--text2)', lineHeight: '24px', marginBottom: '16px' }}>
            No vendemos ni compartimos tu información personal con terceros, excepto cuando sea necesario 
            para proveer nuestros servicios o cuando la ley lo requiera.
          </p>

          <h3 style={{ marginTop: '20px', marginBottom: '12px', fontSize: '16px' }}>5. Retención de Datos</h3>
          <p style={{ color: 'var(--text2)', lineHeight: '24px', marginBottom: '16px' }}>
            <strong>Los registros de ventas, trabajos, turnos y gastos se conservan por un período máximo de 1 (un) año.</strong> 
            Transcurrido este plazo, los datos serán eliminados automáticamente de nuestros sistemas para mantener 
            la eficiencia y fluidez de la aplicación. Te recomendamos exportar o guardar la información importante 
            antes de que se cumpla este período.
          </p>

          <h3 style={{ marginTop: '20px', marginBottom: '12px', fontSize: '16px' }}>6. Tus Derechos</h3>
          <p style={{ color: 'var(--text2)', lineHeight: '24px', marginBottom: '16px' }}>
            Tienes derecho a acceder, corregir o eliminar tu información personal. Para ejercer estos 
            derechos, contáctanos a través de los canales indicados.
          </p>

          <h3 style={{ marginTop: '20px', marginBottom: '12px', fontSize: '16px' }}>7. Contacto</h3>
          <p style={{ color: 'var(--text2)', lineHeight: '24px', marginBottom: '16px' }}>
            Si tienes preguntas sobre esta política de privacidad, contáctanos en:
          </p>
          <p style={{ color: 'var(--accent)', fontWeight: '600' }}>
            📧 tukinegociosapp@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
}
